import React from "react";
import { Modal, Button, Typography } from "antd";
import styled from "styled-components";
import { RefreshBlackIcon , CalendarIcon} from "../../../../assets/PaymentIcon";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";


const { Text } = Typography;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 24px;
    padding: 24px;
    min-width: 580px;
     @media (max-width: 480px) {
    min-width: 100%;
  }
  }

  .ant-modal-header {
    border-bottom: none;
    padding: 0;
  }

  .ant-modal-title {
    font-size: 24px;
    font-weight: 500;
    color: #191114;
  }

  .ant-modal-body {
    margin-top: 16px;
    padding: 0;
  }

  .ant-modal-footer {
    border-top: none;
    padding-top: 32px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
`;

const CancelButton = styled(Button)`
  width:50%;
  height: 56px;
  border-radius: 8px;
  font-weight: 500;
  font-size:16px;
  color: #191114;
  border: 1px solid #d9e4ff;
  background: #fff;
`;

const SwitchButton = styled(Button)`
 width:50%;
  height: 56px;
  border-radius: 8px;
  font-weight: 500;
  background-color: #FFE14E;
  color: #000;
  display: flex;
  align-items: center;
  gap: 6px;
  border:none;

  &:hover {
    background-color: #FFE14E !important;
    opacity: 0.9;
  }
`;

const CalendarBox = styled.div`
 width: 90%;
 height: 80px;
 background: linear-gradient(to left, #F0F6FE00 0%, #F0F6FE 100%);
 border: 1px solid #D9E4FF;
 padding: 16px;
 border-radius: 8px;
 display:flex;
 justify-content:space-between;
 align-items:center;
 margin-top:10px;
  @media (max-width: 480px) {
    height: auto;
    flex-direction:column;
    gap:8px;
  }
`

const SwitchToAutoPaymentModal = ({ open, onCancel, onConfirm, loading }) => {

    const tomorrow = dayjs().add(1, "day").format("DD MMM YYYY");

    const {t} = useTranslation();

  return (
    <StyledModal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      closable
      title="Switch to Manual-payment"
    >
      <Text style={{ fontSize: 16, lineHeight: "22px", color: "#191114",fontWeight:400 }}>
       {t('are_you_sure_want_to_switch')}
      </Text>
   <CalendarBox>
    <div>
        <Text style={{ fontSize: 16, lineHeight: "39px", color: "#191114",fontWeight:300}}>
        {t('your_will_effective')}
       </Text><br/>
        <Text style={{ fontSize: 16, lineHeight: "22px", color: "#191114",fontWeight:500}}>
         {tomorrow} ({t('tomorrow')}),{" "} <span style={{color:"#1859FF"}}>00:00 AM</span>
       </Text>
       </div>
       <CalendarIcon/>
      </CalendarBox>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 32 }}>
        <CancelButton onClick={onCancel}>Cancel</CancelButton>
        <SwitchButton  onClick={onConfirm} loading={loading}>
          <RefreshBlackIcon />
          {t('switch')}
        </SwitchButton>
      </div>
      
    </StyledModal>
  );
};

export default SwitchToAutoPaymentModal;
